import React from 'react';
import { Text } from 'react-native-paper';

export function LiveTab() {
  return <Text>This tab is not supported</Text>;
}
